import axios from "axios";
import { CentroCusto } from "models/centro_custo_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const useManageCenter = () => {
  const [list, setAccountTypeList] = useState<CentroCusto[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] = useState<CentroCusto>(null);
  const nomeRef = useRef(null);
  const deptoRef = useRef(null);
  const cancelRef = useRef();

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      nomeRef.current = null;
      setAccountSelected(null);
    }
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/centro-custo/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setAccountTypeList(response.data);
    }
  }

  const add = () => {
    showModal(true);
  };

  const save = async () => {
    if (nomeRef.current !== null && deptoRef.current !== null) {
      setError(false);
      if (!accountSelected) {
        await addRegister();
      } else {
        await updateRegister();
      }
      await loadData();
    } else {
      setError(true);
    }
  };

  const addRegister = async () => {

    const obj = {
        nome: nomeRef.current,
        departamentoId: deptoRef.current,
        idEmpresa: usuario?.idEmpresa,
      };
      const response = await axios.post(process.env.REACT_APP_API_URL + "/centro-custo/", obj);
      if (response.data) {
        setLoading((prev) => (prev = false));
        showModal(false);
        nomeRef.current = null;
        deptoRef.current = null;
        setAccountSelected(null);
      }

  }

  const updateRegister = async () => {
    console.log(nomeRef.current.value, 'nomeRef.current.value');
    const obj = {
        id: accountSelected.id,
        nome: nomeRef.current.value !== undefined ? nomeRef.current.value : nomeRef.current,
        departamentoId: deptoRef.current.value !== undefined ? deptoRef.current.value : deptoRef.current,
        idEmpresa: usuario?.idEmpresa,
      };
      console.log(obj, 'aiuheuheua')
      const response = await axios.patch(
        process.env.REACT_APP_API_URL + "/centro-custo/" + accountSelected.id,
        obj
      );
      if (response.data) {
        setLoading((prev) => (prev = false));
        showModal(false);
        nomeRef.current = null;
        deptoRef.current = null;
        setAccountSelected(null);
      }
  }

  const edit = (item: CentroCusto) => {
    showModal(true);
    setAccountSelected(item);
    nomeRef.current = item.nome;
    deptoRef.current= item.departamentoId;
  };

  const showDeleteModal = (item: CentroCusto) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/centro-custo/" + accountSelected?.id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      showModal(false);
      nomeRef.current = null;
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  useEffect(() => {
     const initialize = async () => {
        await loadData();
     }
     initialize();
  }, []);
  return {
    list,
    add,
    edit,
    loading,
    show,
    showModal,
    nomeRef,
    accountSelected,
    error,
    save,
    deletar,
    showDeleteModal,
    showDelete,
    cancelRef,
    closeDelete,
    deptoRef
    
  }
};

export default useManageCenter;
